// extracted by mini-css-extract-plugin
export default {"container":"InfoLabelValue_container__YXdam","theme-default":"InfoLabelValue_theme-default__Jv49x","theme-visa":"InfoLabelValue_theme-visa__7PHVM"};